/**
 * @file CorrelationRiskRateProgressionListView.jsx
 * @author Daniel Aguirre
 * @description Correlation Risk Rate Progression List View Page
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';

// Helpers
import {
  joinArrayObject,
  removeNullValuesFromObject
} from 'commons/helpers/utils';
import {
  createColumns,
  getSearchApiKeys,
  getSorterString,
  PAGE_LIMIT
} from '../helper/utils';
import DashboardDetailList from '../dashboardDetailList';

function CorrelationRiskRateProgressionListView({
  dashboardStaffActions,
  clinicId
}) {
  const { t: translate } = useTranslation();
  const [rowData, setRowData] = React.useState([]);
  const {
    classification,
    proggression,
    totalItems: totalItemsParams
  } = useParams();
  const [totalItems, setTotalItems] = useState(totalItemsParams);
  const [dataFilter, setDataFilter] = useState(null);
  const [columns, setColumns] = useState([]);
  const [filter, setFilter] = useState(null);
  const [sorter, setSorter] = useState(null);

  const { getCorrelationRiskRateProgressionListPlus } = dashboardStaffActions;

  const getetData = (offset, pageLimit) => {
    const pageSize = pageLimit || PAGE_LIMIT;
    const joinFilter = joinArrayObject(filter);
    const joinSorter = joinArrayObject(sorter);
    const data = {
      params: {
        idClinic: clinicId,
        filterRiesgoSeleccionado: classification,
        filterVelocidadProgresionSeleccionada: proggression,
        limit: pageSize,
        offset,
        ...joinFilter,
        ...joinSorter
      }
    };
    getCorrelationRiskRateProgressionListPlus(data, (_, resp) => {
      if (resp?.data && resp.data?.totalRegistros != null) {
        setTotalItems(resp.data?.totalRegistros);
        setRowData(resp.data?.listaDetalles ?? []);
        setDataFilter(resp.data);
      }
    });
  };

  useEffect(() => {
    if (clinicId !== null) getetData(1);
  }, [clinicId]);

  useEffect(() => {
    const cols = createColumns(translate, dataFilter);
    setColumns(cols);
  }, [rowData, dataFilter]);

  const handleTableChange = (pagination, filters, sorterFilter) => {
    if (filters || sorterFilter) {
      const convertedFilters = getSearchApiKeys(
        [...columns],
        removeNullValuesFromObject(filters)
      );
      const convertedSorts = getSorterString(sorterFilter);
      setFilter(convertedFilters);
      setSorter(convertedSorts);
    }
  };

  return (
    <DashboardDetailList
      columns={columns}
      rowData={rowData}
      totalItems={totalItems}
      onPaginationChange={getetData}
      onChange={handleTableChange}
      filter={filter}
      sorter={sorter}
    />
  );
}

/**
 * Component definition of proptypes.
 */
CorrelationRiskRateProgressionListView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getCorrelationRiskRateProgressionListPlus: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default CorrelationRiskRateProgressionListView;
